import React , {useState} from 'react';
import emailjs from 'emailjs-com';

const Result = () => {
    return (
        <p className="success-message">Your Message has been successfully sent. We can't wait to get started.</p>
    )
}

function ContentForm({props , formStyle}) {
    const [ result,showresult ] = useState(false);

    const sendEmail = (e) => {
        e.preventDefault();
        emailjs
        .sendForm(
            'service_odnfkdl', 
            'contact_form', 
            e.target, 
            'user_RqvV5zTUFsk1xvMOsmy2X'
        )
        .then((result) => {
            console.log(result.text);
            }, 
            (error) => {
             console.log(error.text);
            }
        );
        e.target.reset();
        showresult(true);
    };

    setTimeout(() => {
        showresult(false);
    }, 5000);

    return (
        <form className={`${formStyle}`} action="" onSubmit={sendEmail}>
           
 
 <div className="rn-address">
 <h4 className="title">Tell us about what you're interested in creating</h4>
			<div className="form-group">
                <input 
                type="text"
                name="fullname"
                placeholder="Your Name"
                required
                />
            </div>

            <div className="form-group">
                <input 
                type="email"
                name="email"
                placeholder="Email Address"
                required
                />
            </div>
			
			<div className="form-group">
            </div>
            <div className="form-group">
                <input 
                type="text"
                name="Organization"
                placeholder="Organization"
                required
                />
            </div>
            <div className="form-group">
                <input 
                type="text"
                name="subject"
                placeholder="Subject"
                required
                />
            </div>

            <div className="form-group">
                <textarea 
                name="message"
                placeholder="Your Message"
                required
                >
                </textarea>
            </div>
</div>
            <div className="form-group">
                <button className="btn-default btn-large">Submit Now</button>
            </div> 

            <div className="form-group">
                {result ? <Result /> : null}
            </div> 
        </form>
    )
}
export default ContentForm;
